import { createApi } from '@reduxjs/toolkit/query/react'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const vendorReviewApiService = createApi({
  reducerPath: 'vendorReviewApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/vendor-reviews/'),
  tagTypes: ['VendorReview'],
  endpoints: (builder) => ({
    // Get pending reviews for moderation
    getPendingReviews: builder.query({
      query: (args) => ({
        url: 'admin/pending',
        method: 'GET',
        params: args
      }),
      providesTags: ['VendorReview'],
      keepUnusedDataFor: 0
    }),
    // Get all reviews with optional status filter
    getAllReviews: builder.query({
      query: (args) => ({
        url: 'admin/all',
        method: 'GET',
        params: args
      }),
      providesTags: ['VendorReview'],
      keepUnusedDataFor: 0
    }),
    // Get review statistics
    getReviewStats: builder.query({
      query: () => ({
        url: 'admin/stats',
        method: 'GET'
      }),
      providesTags: ['VendorReview'],
      keepUnusedDataFor: 0
    }),
    // Get single review by ID
    getReviewById: builder.query({
      query: (reviewId) => ({
        url: `admin/${reviewId}`,
        method: 'GET'
      }),
      providesTags: ['VendorReview']
    }),
    // Approve a review
    approveReview: builder.mutation({
      query: (reviewId) => ({
        url: `admin/${reviewId}/approve`,
        method: 'POST'
      }),
      invalidatesTags: ['VendorReview']
    }),
    // Reject a review
    rejectReview: builder.mutation({
      query: ({ reviewId, reason }) => ({
        url: `admin/${reviewId}/reject`,
        method: 'POST',
        body: { reason }
      }),
      invalidatesTags: ['VendorReview']
    }),
    // Delete a review
    deleteReview: builder.mutation({
      query: (reviewId) => ({
        url: `admin/${reviewId}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['VendorReview']
    })
  })
})

export const {
  useGetPendingReviewsQuery,
  useGetAllReviewsQuery,
  useGetReviewStatsQuery,
  useGetReviewByIdQuery,
  useApproveReviewMutation,
  useRejectReviewMutation,
  useDeleteReviewMutation
} = vendorReviewApiService

